<siq-app-header [config]="config"></siq-app-header>
<siq-query-mode #queryMode [disabled]="false" [modalConfig]="queryModeModalConfig" [overrideSchema]="overrideSchema"></siq-query-mode>

<siq-js-affinities-stepper
  [formData]="formData"
  [queryMode]="queryMode"
  [submit]="submit"
  [overrideSchema]="overrideSchema"
>
</siq-js-affinities-stepper>
